import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: 'en',
    backend: {
      /* translation file path */
      loadPath: '/assets/i18n/{{ns}}/{{lng}}.json',
    },
    fallbackLng: 'en',
    debug: false,
    /* can have multiple namespace, in case you want to divide a huge translation into smaller pieces and load them on demand */
    ns: ['appointment', 'common', 'cough-test', 'daily-check-in', 'daily-medical-care', 'knowledge-bank', 'medical-history', 'mental-health', 'questions', 'recommended', 'welcome', 'sign-up', 'speak-doctor', 'user-account', 'status', 'feedback'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      formatSeparator: ',',
    },
    react: {
      wait: true,
    },
  });

export default i18n;
